const ITEMS = [
    { text: "Inside", serif: true },
    { text: "IMMERSIVE 360° WALKTHROUGHS", serif: false },
    { text: "Outside", serif: true },
    { text: "ONE CONTINUOUS EXPERIENCE", serif: false },
    { text: "Above", serif: true },
    { text: "AERIAL & DRONE CINEMATOGRAPHY", serif: false },
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            className="overflow-hidden border-y border-[#121211]/10 bg-[#FBF9F5] py-7"
            data-testid="editorial-marquee"
        >
            <div className="marquee-track flex w-max items-baseline gap-10 whitespace-nowrap pr-10">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-baseline gap-10">
                        {row.map((item, i) =>
                            item.serif ? (
                                <span
                                    key={`${half}-${i}`}
                                    className="font-display text-4xl font-light italic text-[#121211] sm:text-5xl"
                                >
                                    {item.text}
                                    <span className="mx-6 align-middle font-mono2 text-xs not-italic text-[#6B6862]">
                                        ·
                                    </span>
                                </span>
                            ) : (
                                <span
                                    key={`${half}-${i}`}
                                    className="translate-y-[-6px] font-mono2 text-[11px] tracking-[0.34em] text-[#6B6862]"
                                >
                                    {item.text}
                                    <span className="mx-6 text-[#121211]/30">·</span>
                                </span>
                            ),
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
